$(function(){
    if ($('#side01').length) {
        sidebarAnimation01();
    }

    function sidebarAnimation01() {
        $(window).scroll(function() {
            var deviceTop = $(window).scrollTop() + $(window).height()/2;
            var sec01Bottom = $('#concept01').offset().top + $('#concept01').innerHeight();
            var sec02Bottom = $('#concept02').offset().top + $('#concept02').innerHeight();
            var sec03Bottom = $('#concept03').offset().top + $('#concept03').innerHeight();
            var sec04Bottom = $('#concept04').offset().top + $('#concept04').innerHeight();
            var sec05Bottom = $('#concept05').offset().top + $('#concept05').innerHeight();
            var sec06Bottom = $('#concept06').offset().top + $('#concept06').innerHeight();

            var sec01Top = $('#concept01').offset().top;
            var sec02Top = $('#concept02').offset().top;
            var sec03Top = $('#concept03').offset().top;
            var sec04Top = $('#concept04').offset().top;
            var sec05Top = $('#concept05').offset().top;
            var sec06Top = $('#concept06').offset().top;
    
            if (sec01Top < deviceTop && deviceTop < sec01Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar01').addClass('js-active');
            } else if (sec02Top < deviceTop && deviceTop < sec02Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar02').addClass('js-active');
            } else if (sec03Top < deviceTop && deviceTop < sec03Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar03').addClass('js-active');
            } else if (sec04Top < deviceTop && deviceTop < sec04Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar04').addClass('js-active');
            } else if (sec05Top < deviceTop && deviceTop < sec05Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar05').addClass('js-active');
            } else if (sec06Top < deviceTop && deviceTop < sec06Bottom ) {
                $('.side-li').removeClass('js-active');
                $('.js-sidebar06').addClass('js-active');
            }  else {
                $('.side-li').removeClass('js-active');
            }
        });
    }
});